import { Box, Image } from '@chakra-ui/react';
import type { Mention } from '@fluenceur/types';
import { MentionThumbnailPreviewSurface } from './MentionThumbnailPreviewSurface';

interface MentionImageThumbnailProps {
  imageUrl: string;
  mention: Mention;
  openOnClick?: boolean;
  /** The address failed to load (an expired signed URL): the caller repairs it. */
  onError?: () => void;
}

/**
 * Component for displaying an image thumbnail with gradient overlay.
 */
const MentionImageThumbnail: React.FC<MentionImageThumbnailProps> = ({
  imageUrl,
  mention,
  openOnClick = true,
  onError,
}) => {
  return (
    <MentionThumbnailPreviewSurface mentionId={mention.id} openOnClick={openOnClick}>
      <Image
        src={imageUrl || undefined}
        onError={onError}
        alt="Mention media"
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        objectFit="cover"
      />

      {/* Gradient overlay */}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bgGradient="linear(to-b, transparent 60%, blackAlpha.200 100%)"
        pointerEvents="none"
      />
    </MentionThumbnailPreviewSurface>
  );
};

export default MentionImageThumbnail;
